import { useMemo } from 'react';
import MinesGameBoardSkeleton from '../Skeleton';
import { MinesBoardCellsProps } from './props';
import styles from './styles.module.scss';
import MinesBoardCell from './Cell';

export default function MinesBoardCells({
  isDisabled = false,
  isLoading,
  bet,
  onClick,
  isBackgroundPaper,
  isBoletim,
}: MinesBoardCellsProps) {
  const Cells = useMemo(
    () =>
      Array.from({ length: 25 }).map((_, position) => (
        <MinesBoardCell
          key={`mines-board-cell-${position}`}
          bet={bet}
          isDisabled={isDisabled}
          position={position}
          onClick={onClick}
          isBackgroundPaper={isBackgroundPaper}
        />
      )),
    [bet, isDisabled, onClick, isBackgroundPaper],
  );

  return (
    <div
      className={`${styles.container} ${isDisabled ? styles['container--disabled'] : ''} ${isBoletim ? styles['container--boletim'] : ''}`}
    >
      {isLoading ? <MinesGameBoardSkeleton /> : Cells}
    </div>
  );
}
